import React from 'react';

import styles from './DonationCard.module.scss';

const { 'donation-card': donationCardClass, 'donation-url': donationUrlClass } = styles;

const DonationCard = ({ title, description, url }) => {
  return (
    <div className={donationCardClass}>
      <h2>{title}</h2>
      {!!description && <p>{description}</p>}
      {!!url && (
        <button>
          <a href={url} target="_blank" rel="noopener noreferrer">
            Donate now
          </a>
        </button>
      )}
    </div>
  );
};

export default DonationCard;
